<template>
  <div>
    <!-- <div>
      <h1>{{ this.routerEmail }}</h1>
      <h1>{{ this.isIncomingCall }}</h1>
      <h1>{{ this.call_id }}</h1>
      <h1>{{ this.urlQuery }}</h1>
    </div> -->
  </div>
</template>
<script>
const crypto = require('crypto');
export default {
  data() {
    window.$this = this;
    return {
      params: {},
      data: {},
      routerEmail: '', //123@zyy.com  wangjuan01@yuhong.com.cn
      gPhone: '', //客服电话
      isIncomingCall: '', //呼入的客户电话
      url: '',
      query: '',
      call_id: '', //录音id
      urlQuery: '', //url的所有参数
      record: {} //录音内容
    };
  },
  mounted() {
    this.urlQuery = this.$route.query;
    this.routerEmail = decodeURI(this.$route.query.agent_email);
    this.isIncomingCall = this.$route.query.phone;
    this.call_id = this.$route.query.call_id;
    console.log(
      this.routerEmail,
      '-----------this.routerEmail',
      this.isIncomingCall,
      '-------this.isIncomingCal',
      this.call_id,
      '-----------this.call_id'
    );
    this.getPhone(() => {
      this.recording();
      this.CallFSGOApi();
      this.getData(() => {
        sessionStorage.clear();
        // this.$util.cookie.deleteCookie('X-Auth-Token');
        this.jump();
      });
    });
  },
  methods: {
    // 页面跳转
    jump() {
      this.$router.push({
        path: '/IncomingCall',
        query: {
          app_key_code: this.query,
          LanderPhone: this.gPhone,
          isIncomingCall: this.isIncomingCall,
          call_id: this.call_id
        }
      });
    },
    recording() {
      var params = {
        call_id: this.call_id
      };
      this.osg.ajax(
        '/i/ud/downloadCallLog.do',
        params,
        res => {
          this.record = res.data.entity;
          console.log(this.record, '--------this.record录音数据');
        }
        // { noload: true }
      );
    },
    getPhone(callback) {
      if (typeof this.routerEmail == 'undefined') {
        alert('发生错误');
      } else {
        var params = {
          email: this.routerEmail
        };
        this.osg.ajax(
          '/i/ud/exchangePhone.do',
          params,
          res => {
            this.gPhone = res.data;
            console.log(this.gPhone, '--------this.gPhone');
            if (callback) callback();
          },
          { noload: true }
        );
      }
    },
    CommonSign(apiParams, app_secret) {
      /** 通用 md5 签名函数 */
      const shasum = crypto.createHash('md5');
      if (apiParams == null || !(apiParams instanceof Object)) {
        return '';
      }

      /** 获取 apiParms中的key 去除 sign key,并排序 */
      let sortedKeys = Object.keys(apiParams)
        .filter(item => item !== 'sign')
        .sort();
      /** 排序后字符串 */
      let sortedParamStr = '';
      // 拼接字符串参数
      sortedKeys.forEach(function(key, index, ary) {
        let keyValue = apiParams[key];
        if (keyValue instanceof Object) keyValue = JSON.stringify(keyValue);
        if (key != 'sign' && keyValue != null && keyValue != '') {
          sortedParamStr += `${key}${keyValue}`;
        }
      });
      /** 拼接加密字符串 */
      let paraStr = app_secret + sortedParamStr;

      shasum.update(paraStr);
      let sign = (apiParams.sign = shasum.digest('hex'));
      return sign;
    },

    CallFSGOApi() {
      // 随机生成数
      var num = '';
      for (var i = 0; i < 19; i++) {
        num += Math.floor(Math.random() * 10);
      }
      // 生成时间戳
      var time = Date.parse(new Date()) / 1000;
      let app_secret = '838uf75w60693c4480p02oakl'; //13146050328
      /** api参数拼接 */ const apiParams = {
        accountName: this.gPhone,
        // 随机数 动态 防注入
        nonce: num,
        appId: '1340835581184723420',
        // 时间戳
        timestamp: time,
        // ****************切换库时需要修改路径***************
        redirectUrl: 'https://www.fsgo365.cn/IncomingCall'
      };
      this.params = apiParams;
      console.log(this.params, '-------this.params');
      /** apiURL */
      // const apiUrl = `${jstConfig}/${apiPath}`;
      this.CommonSign(apiParams, app_secret);
    },
    getData(callback) {
      this.osg.ajax(
        'i/sso/signLogin.do',
        this.params,
        res => {
          this.url = res.redirectUrl;
          this.query = res.app_key_code;
          if (callback) callback();
          console.log(this.query, '------- this.query');
        },
        {
          header: { 'Content-Type': 'application/json', requestDataType: 'json' }
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped></style>
